import { OnInit, Component, Inject, Optional } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { DAConfirmPopup } from '../DAInterimPopup/confirmPopup/da-newuser-confirm-popup';
import { Router } from '@angular/router';

@Component({
    selector: 'da-splash-popup',
    templateUrl: './da-splash-popup.component.html'
})
export class DASplashPopup implements OnInit {
    showSplashPopup: boolean = false;
    isMobile: boolean;
    constructor(private dialog: MatDialog,
    private dialogref: MatDialogRef<DASplashPopup>,
    private router: Router,
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,) {
      this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
      this.isMobile = appSettings.deviceType == 'mobile';
  }

  ngOnInit() {
    // to do
  }

  openConfirmPopup() {
    this.dialog.open(DAConfirmPopup,  {width: this.isMobile ? '80vw' : '50vw'} );
    this.dialogref.close();
  }

  gotToMixin() {
      this.router.navigateByUrl('/nxi/digital-advise-mixin');
      this.dialogref.close();
  }
}
